import { useState } from "react";
import Practice, { PRACTICESTATES } from "../../model/practice";
import { setPracticeState, setPracticeInfo, incrementQuestionNumber, setQuestions, incrementQuestionInfo } from "../providers/practice";

export function usePractice(): [Practice, Function, Function, Function, Function, Function] {
    const options: string[] = [];
    const [state, setState] = useState({
        state: PRACTICESTATES.START_GAME, questions: [], question: "", options: options,
        duration: 0, questionNumber: 0, correctAnswers: 0, timeToAnswer: 0, startTime: 0,
    });

    return [state,
        (matchmakingState: PRACTICESTATES) => setPracticeState(setState, matchmakingState),
        (question: string, options: string[], duration: number) => setPracticeInfo(setState, question, options, duration),
        () => incrementQuestionNumber(setState),
        (questions: any) => setQuestions(setState, questions),
        (incrementCorrect: number, timeToAnswer: number) => incrementQuestionInfo(setState, incrementCorrect, timeToAnswer),
    ];
}
